import { render, staticRenderFns } from "./PromoScreen.vue?vue&type=template&id=708d7eee"
import script from "./PromoScreen.vue?vue&type=script&lang=js"
export * from "./PromoScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports